// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { OrderStrategy } from '@innolab-trader/tradovate-types'
import type { OrderAction } from '@innolab-trader/tradovate-types/src/enums/orderAction'
import type { RejectedReason } from '@innolab-trader/tradovate-types/src/enums/rejectedReason'

export interface StartOrderStrategy {
  accountId?: number
  accountSpec?: string
  symbol: string
  orderStrategyTypeId: number
  action: OrderAction
  params?: string
  uuid?: string
  customTag50?: string
  isAutomated?: boolean
}

export interface OrderStrategyStatusResponse {
  errorText?: string
  failureReason?: RejectedReason
  orderStrategy?: OrderStrategy
}

/**
 * Validate StartOrderStrategy request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateStartOrderStrategy(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateStartOrderStrategy(request: StartOrderStrategy): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (typeof req.accountSpec === 'string' && req.accountSpec.length > 64) {
    errors.push({
      field: 'accountSpec',
      code: 'too_long',
      message: 'accountSpec must not exceed 64 characters',
      argument: '64'
    })
  }

  if (req.symbol === undefined || req.symbol === null) {
    errors.push({
      field: 'symbol',
      code: 'required',
      message: 'symbol is required'
    })
  }
  if (typeof req.symbol === 'string' && req.symbol.length > 64) {
    errors.push({
      field: 'symbol',
      code: 'too_long',
      message: 'symbol must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.symbol === 'string' && req.symbol.trim() === '') {
    errors.push({
      field: 'symbol',
      code: 'required',
      message: 'symbol cannot be empty'
    })
  }

  if (req.orderStrategyTypeId === undefined || req.orderStrategyTypeId === null) {
    errors.push({
      field: 'orderStrategyTypeId',
      code: 'required',
      message: 'orderStrategyTypeId is required'
    })
  }

  if (req.action === undefined || req.action === null) {
    errors.push({
      field: 'action',
      code: 'required',
      message: 'action is required'
    })
  }

  if (typeof req.params === 'string' && req.params.length > 8192) {
    errors.push({
      field: 'params',
      code: 'too_long',
      message: 'params must not exceed 8192 characters',
      argument: '8192'
    })
  }

  if (typeof req.uuid === 'string' && req.uuid.length > 64) {
    errors.push({
      field: 'uuid',
      code: 'too_long',
      message: 'uuid must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.customTag50 === 'string' && req.customTag50.length > 64) {
    errors.push({
      field: 'customTag50',
      code: 'too_long',
      message: 'customTag50 must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const startOrderStrategy = postEndpoint<StartOrderStrategy, OrderStrategyStatusResponse>('/orderStrategy/startOrderStrategy')
